module.exports = __webpack_public_path__ + "img/SamplesRegister.794e9168.svg";